import React from "react";
import videosource from "./Assets/HorizontalVideo.mp4";
import videosource2 from "./Assets/HorizontalVideo2.mp4";
import "./horizontalbanner.css"; // Import the CSS file

function HorizontalBanner() {
  return (
    <div className="totalContainerClass">
      <div className="flexWrapper">
        <div className="gridContainer2">
          <div className="container2">
            <p className="textAlightLeft3 TextContent">
              Bioelectric therapy works by applying low-level electrical
              currents to specific areas of the body, stimulating the natural
              flow of energy along the meridians as understood in Traditional
              Chinese Medicine. This gentle stimulation enhances circulation,
              promotes the release of endorphins, and encourages natural cell
              regeneration, which aids in tissue repair. Additionally, the
              therapy helps reduce inflammation, alleviating pain and discomfort
              while supporting the body’s innate healing processes. As a result,
              clients often experience not only immediate relief but also
              long-lasting improvements in their overall health and well-being.
            </p>
          </div>

          <div className="container1">
            <video
              className="videoStyle HorizontalVideo"
              autoPlay
              muted
              loading="lazy"
              playsInline
              loop
            >
              <source src={videosource2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
      <div className="flexWrapper">
        <div className="gridContainer">
          <div className="container1">
            <video
              className="videoStyle HorizontalVideo"
              loading="lazy"
              autoPlay
              muted
              playsInline
              loop
            >
              <source src={videosource} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="container2">
            <p className="textAlightLeft2 TextContent">
              Bioelectric therapy is a safe and non-invasive treatment option
              that utilizes low-level electrical currents to stimulate the
              body’s natural healing processes. The therapy is designed with
              patient safety in mind, employing gentle techniques that are
              well-tolerated by clients of all backgrounds. Each session is
              conducted by our highly trained technicians, who ensure that all
              protocols are followed to maintain a hygienic environment.
              Additionally, the therapy is customized to suit individual health
              needs, allowing clients to receive targeted care without the risks
              associated with invasive procedures
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HorizontalBanner;
